// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__qNQ62","secondary":"Button_secondary__4Emk1","tetriary":"Button_tetriary__f654r"};